var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import Select from 'react-select';
import { DropdownIndicator, Option, MultiValueContainer } from './_utilityComponents';
import { createPillSelectStyles } from './styles';
import '../../css/clydePillSelect.css';
var ClydePillSelect = function (_a) {
    var options = _a.options, placeholder = _a.placeholder, onChange = _a.onChange, value = _a.value, disabled = _a.disabled, hidden = _a.hidden, direction = _a.direction, isSearchable = _a.isSearchable, showSelectAll = _a.showSelectAll;
    var components = { DropdownIndicator: DropdownIndicator, Option: Option, MultiValueContainer: MultiValueContainer };
    var visibleOptions = __spreadArray([], options, true);
    var handleChange = function (newValue, meta) {
        var _a;
        if (!showSelectAll) {
            onChange(newValue, meta);
            return;
        }
        var update = newValue.filter(function (v) { return v.value !== 'selectAll'; });
        var isSelectAll = ((_a = meta === null || meta === void 0 ? void 0 : meta.option) === null || _a === void 0 ? void 0 : _a.value) === 'selectAll';
        var isDeselect = meta.action === 'deselect-option';
        var enabledOptions = options.filter(function (v) { return (!v.isDisabled && v.value !== 'selectAll'); });
        if (isSelectAll) {
            if (isDeselect) {
                update = [];
            }
            else {
                update = enabledOptions;
            }
        }
        else if (update.length === enabledOptions.length && !isDeselect) {
            update = enabledOptions;
        }
        onChange(update, meta);
    };
    var selectAllOption = {
        label: 'Select All',
        value: 'selectAll',
    };
    if (showSelectAll && options.length) {
        if (value.length === visibleOptions.length) {
            value.unshift(selectAllOption);
        }
        visibleOptions.unshift(selectAllOption);
    }
    return React.createElement(React.Fragment, null, !hidden
        && React.createElement(Select, { options: visibleOptions, styles: createPillSelectStyles(direction || 'col'), components: components, placeholder: placeholder, hideSelectedOptions: false, closeMenuOnSelect: false, isSearchable: isSearchable || false, onChange: handleChange, value: value, isDisabled: disabled || false, isMulti: true }));
};
export default ClydePillSelect;
